const tinyChar = {
    " ": 0.56,
    ".": 0.62,
    "f": 0.68,
    "i": 0.68,
    "j": 0.68,
    "l": 0.68,
    "r": 0.66,
    "t": 0.68
}

export function getByteCount(str) {
    let count = 0
    for (let i = 0; i < str.length; i++) {
        const c = str.charAt(i)
        const value = tinyChar[c]
        if (value !== undefined) {
            count += value
        } else if (/^[\u0000-\u00ff]$/.test(c)) {
            count += 1
        } else {
            count += 2
        }
    }
    return Math.ceil(count)
}


// WEBPACK FOOTER //
// ./components/pipeline-goodsRecommend/lib/BytesCount/index.js